import React from 'react';
import InputRange from 'react-input-range';

import'./browse_filter_range_component.less';

export default class ReactRange extends React.Component{

  constructor(props){
    super(props);

    this.state = {
      value: {
        min: this.props.browseFilter.packageValueFrom,
        max: this.props.browseFilter.packageValueTo
      }
    }
  }

  componentDidMount(){

  }

  updateSliderValue = (value)=>{
    const self = this;
    let browseFilter = Object.assign({}, self.props.browseFilter);
    browseFilter.packageValueFrom = value.min;
    browseFilter.packageValueTo = value.max;
    this.props.updateParentStateCallback(browseFilter);
  }



  componentWillReceiveProps(newProps){
    this.setState({
      value: {
        min: newProps.browseFilter.packageValueFrom,
        max: newProps.browseFilter.packageValueTo
      }
    })
  }

  render(){
    const {state, props} = this;
    const {range} = this.props;
    return(
      <div className="range-component-wrap">
        <div className="curr-range">
          ${state.value.min}&nbsp;-&nbsp;${state.value.max}
        </div>
        <InputRange maxValue={range.max} minValue={range.min} step={range.step}  formatLabel={value => `${value}`} value={this.state.value} onChange={value => this.setState({ value: value })} onChangeComplete={this.updateSliderValue} />
        <div className="cf">
          <div className="f-l range-extremes">${range.min}</div>
          <div className="f-r range-extremes">${range.max}</div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// app/browse_packages/browse_filter/browse_filter_range_component.jsx